<button
  *ngIf="canPrintForm()"
  class="btn btn-sm btn-secondary ms-2 me-2 mb-1"
  (click)="printForm()"
  [title]="'measurementsGridButtonTitlePrintForm' | localize"
  data-testid="print-form-button"
>
  <i class="fa fa-print"></i>
</button>
